<template>
  <div class="home">
    <div class="userInfo">
      <div class="header">
        <div class="pHeader">
          <h3>受助人列表</h3>
          <h2 @click="$router.go(-1)">返回</h2>
        </div>
        <div class="line"></div>
      </div>
      <div class="nextNav">
        <div class="nextNavLeft">
          <ul>
            <li
              :class="index == dentityIndex ? 'selected' : ''"
              :style="index == 0 ? 'border-left:none' : ''"
              v-for="(item, index) in dentityNav"
              :key="item"
              @click="changeDentity(item, index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="nextNavRight">
          <el-input
            placeholder="搜索"
            suffix-icon="el-icon-search"
            @keyup.enter.native="search"
            v-model="keyword"
            size="mini"
            style="width: 0.8rem"
          ></el-input>
          <el-select
            v-model="statusvalue"
            @clear="clearStatus"
            @change="changeStatus"
            size="mini"
            clearable
            placeholder="请选择排序方式"
          >
            <el-option
              v-for="item in optionsStatus"
              :key="item.sort"
              :label="item.value"
              :value="item.sort"
            ></el-option>
          </el-select>
          <el-select
            v-model="value"
            @change="selectChange"
            size="mini"
            clearable
            placeholder="请选择排序方式"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.value"
              :value="item"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="user">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <!-- <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            min-width="4%"
          ></el-table-column> -->
          <el-table-column label="序号" align="center" min-width="4%">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (paginations.page_index - 1) * 10 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="受助人姓名"
            align="center"
            min-width="5%"
          ></el-table-column>
          <el-table-column
            prop="donortime"
            label="时间"
            align="center"
            min-width="6%"
          ></el-table-column>
          <el-table-column
            prop="money"
            label="受助金额"
            align="center"
            min-width="5%"
          ></el-table-column>
          <el-table-column
            prop="phone"
            label="电话号码"
            align="center"
            min-width="5%"
          ></el-table-column>
          <el-table-column
            prop="checks"
            label="状态"
            align="center"
            min-width="5%"
          >
            <template slot-scope="scope">
              <span style="color: red" v-if="scope.row.checks == 1"
                >核对失败:{{ scope.row.reject }}</span
              >
              <span style="color: #999999" v-else-if="scope.row.checks == 0"
                >核对中</span
              >
              <span style="color: #00ff00" v-else-if="scope.row.checks == 2"
                >已核对</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="contact"
            show-overflow-tooltip
            label="联系地址"
            align="center"
            min-width="5%"
          ></el-table-column>
          <el-table-column label="资料文件" align="center" min-width="8%">
            <template slot-scope="scope">
              <el-button size="mini" @click="download(scope.row, scope.$index)"
                >个人文件</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tspage" v-if="paginations.total > paginations.page_size">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="paginations.page_index"
          :page-size="paginations.page_size"
          :total="paginations.total"
          layout="prev, pager, next"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js";
import { BASE_URL } from "@/utils/base.js";
import { getSzUserList } from "@/api/user.js";
export default {
  name: "Home",
  data() {
    return {
      dentityNav: ["个人", "团队"],
      dentityIndex: 0,
      tableData: [],
      value: { value: "按时间由低到高排序", content: "时间", sort: false },
      keyword: "",
      statusvalue: null,
      options: [
        { value: "按时间由低到高排序", content: "时间", sort: false },
        { value: "按时间由高到低排序", content: "时间", sort: true },
        { value: "按金额由高到低排序", content: "金额", sort: false },
        { value: "按金额由低到高排序", content: "金额", sort: true },
      ],
      optionsStatus: [
        { value: "核对中", sort: 0 },
        { value: "核对失败", sort: 1 },
        { value: "已核对", sort: 2 },
      ],
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
    };
  },
  mounted() {
    if (this.$route.params.pid) {
      this.getList();
    } else {
      this.$router.go(-1);
    }
    this.$nextTick(function () {
      Bus.$emit("getCmsCurrent", "/myProgram");
    });
  },
  methods: {
    // 获取列表
    async getList() {
      let userList = new FormData();
      userList.append("dentity", this.dentityNav[this.dentityIndex]);
      userList.append("page", this.paginations.page_index);
      userList.append("rows", this.paginations.page_size);
      userList.append("keyword", this.$route.params.pid);
      userList.append("sids", this.value.sort);
      userList.append("school", this.value.content);
      if (this.keyword) {
        userList.append("name", this.keyword);
      }
      if (this.statusvalue == 0 || this.statusvalue) {
        userList.append("xueyuan", this.statusvalue);
      }
      let listInfo = await getSzUserList(userList);
      this.paginations.total = listInfo.total;
      this.tableData = listInfo.rows;
    },
    // 排序下拉框选中
    selectChange(item) {
      this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size:5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      }
      this.statusvalue = null;
      this.getList();
    },
    // 下拉框清空
    clearStatus() {
      this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size:5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      }
      this.statusvalue = null;
      this.getList();
    },
    // 下拉框状态值切换
    changeStatus(item) {
      this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size:5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      }
      this.statusvalue = item;
      this.getList();
    },
    // 文件下载
    download(item, index) {
      window.open(BASE_URL + item.file, "_blank");
    },
    // 编辑
    handleEdit(item, index) {},
    // 身份切换
    changeDentity(item, index) {
      this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size:5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      }
      this.dentityIndex = index;
      this.getList();
    },
    indexMethod(index) {
      return index + (this.paginations.page_index - 1) * 10 + 1;
    },
    // 分页
    handleCurrentChange(val) {
      this.paginations.page_index = val;
      this.getList();
    },
    // 搜索
    search() {
      if (this.keyword) {
        this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size:5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      }
        this.getList();
      } else {
        this.$message.warning("搜索内容不能为空");
      }
    },
  },
  components: {},
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  padding: 10px 0 40px;
  margin-bottom: 60px;
  min-height: calc(100vh - 200px);
  .userInfo {
    margin: 0 50px;
    .header {
      width: 100%;
      .pHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3 {
          margin: 20px 0;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
        }
        h2 {
          width: 100px;
          height: 26px;
          line-height: 26px;
          color: #fff;
          font-size: 12px;
          border-radius: 5px;
          text-align: center;
          background-color: #0687c8;
          cursor: pointer;
        }
      }

      .line {
        width: 100%;
        background-color: #dbdbdb;
        height: 1px;
      }
    }
    .nextNav {
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .nextNavLeft {
        ul {
          display: flex;
          li {
            width: 70px;
            font-size: 14px;
            height: 14px;
            line-height: 14px;
            border-left: 1px solid #ebebeb;
            color: #4d4d4d;
            text-align: center;
            cursor: pointer;
          }
          .selected {
            color: #0687c8;
          }
        }
      }
      .nextNavRight {
        /deep/ .el-input {
          width: 160px;
          margin-left: 20px;
        }
      }
    }
    .tspage {
      margin: 30px 0 30px;
      text-align: center;
      /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #0687c8;
        border: none;
      }
      /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
        background-color: #fff; // 进行修改未选中背景和字体
        border: 1px solid #ededed;
        // color: #fff;
      }
      /deep/ .el-pagination.is-background button {
        background-color: #fff; // 进行修改未选中背景和字体
        border: 1px solid #ededed;
        // color: #fff;
      }
    }
  }
}
</style>